/**
 * A SelectList is a kind of non-empty list representing a selection in a UI
 */
export class SelectList<T> {
  constructor(
    readonly before: T[],
    readonly selected: T,
    readonly after: T[],
  ) {}

  toList() {
    return [...this.before, this.selected, ...this.after]
  }

  map<U>(fn: (value: T, index: number) => U): SelectList<U> {
    return new SelectList(
      this.before.map((v, i) => fn(v, i)),
      fn(this.selected, this.before.length),
      this.after.map((v, i) => fn(v, this.before.length + 1 + i)),
    )
  }

  filter(predicate: (value: T, index: number) => boolean): SelectList<T> {
    return new SelectList(
      this.before.filter((v, i) => predicate(v, i)),
      this.selected,
      this.after.filter((v, i) => predicate(v, this.before.length + 1 + i)),
    )
  }

  [Symbol.iterator](): Iterator<T> {
    return this.toList()[Symbol.iterator]()
  }
}
